import {useEffect, useMemo} from 'react';

import {BaseVehicle} from '../../core/types/BaseVehicle';
import {useWizardStepId} from '../useWizardStepId';
import {useVehicleFormContext} from './useVehicleFormContext';

/**
 * Registers a field name to the current wizard step boundary so
 * step-level indicators can track it. No-ops when outside a StepBoundary.
 */
export function useStepFieldRegistration(
  fieldName: keyof BaseVehicle | string,
  stepIdOverride?: string | null
) {
  const {fieldRegistry} = useVehicleFormContext<BaseVehicle>();
  const stepIdFromContext = useWizardStepId();
  const effectiveStepId = stepIdOverride === null ? null : (stepIdOverride ?? stepIdFromContext);

  const name = useMemo(() => String(fieldName), [fieldName]);

  useEffect(
    function registerStepField() {
      if (!effectiveStepId) {
        return undefined;
      }
      fieldRegistry.add(effectiveStepId, name);
      return () => {
        fieldRegistry.remove(name);
      };
    },
    [fieldRegistry, effectiveStepId, name]
  );
}
